import { BaseModal } from './BaseModal'
import { Registration } from '../../components/user/Registration'
import { Profile } from '../../components/user/Profile'
import { User, AuthedUser } from '../../lib/user'
import { SEARCH_PARAM_SIGNIN } from '../../constants/strings'

type Props = {
  user: User
  isOpen: boolean
  handleClose: (signout: boolean) => void
  onPayStationClose: (event: any, data: any) => void
}

export const ProfileModal = ({ user, isOpen, handleClose, onPayStationClose}: Props) => {
  const title = user ? "Profile" : "Sign In"
  const close = (signout: boolean) => {
    if(document.activeElement !== document.body &&  
      document.activeElement?.id !== 'close') {
      return
    }
    handleClose(signout);
  }

  return (
    <BaseModal title={title} isOpen={isOpen} handleClose={() => close(false)}>
      {!user.isAuthed() && <Registration redirectUrl={`/?${SEARCH_PARAM_SIGNIN}`} />}
      {user instanceof AuthedUser &&
        <Profile user={user}
          onSignOut={() => handleClose(true)}
          onPayStationClose={onPayStationClose}/ >
      }
    </BaseModal>
		)
}
